<div class="l-top-navi">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner l-top-navi__inner--has-progress">
        <div class="l-top-navi__heading-area clear-left-margin">
          <h1 class="l-top-navi__heading-text" [innerHTML]="'label.searchByEmd' | staticMsg"></h1>
        </div>
      </div>
    </div>
  </div>
</div>
